import { createSelector } from 'reselect';

import IState from 'types/Istore';

const marketsTopCoinsSelector = (state: IState) => state.marketsCard.topCoins;

/**
 * @description This selector is used to get the top gainers from the markets cards state.
 * @returns {string[]} The top gainers.
 * @example
 * ['BTCUSDT', 'ETHUSDT', 'DOGEUSDT']
 */
export const getTopGainersSelector = createSelector(
  marketsTopCoinsSelector,
  marketsTopCoins => {
    return marketsTopCoins !== '' ? marketsTopCoins.split('-') : [];
  }
);

export default marketsTopCoinsSelector;
